import { getL11nString } from "@/l11n/l11n";
import AppStoreBadges from "./AppStoreBadges";

export default function AppDownloadModal() {
  return (
    <div className="flex flex-col items-center text-center p-4">
      <p className="text-xl font-semibold mb-2">{getL11nString("install_taalia")}</p>
      <p className="text-sm text-gray-600 mb-4">{getL11nString("why_install")}</p>
      <AppStoreBadges />
    </div>
  );
}
